import { useLang } from "../context/LanguageContext";
import { FadeUp, InviewMaskLine, RevealImage } from "../components/Reveal";
import InquiryForm from "../components/InquiryForm";
import { TurnkeySection, CostsSection } from "../components/HomeSections";

const IMG = "/images/dealers.webp";

export default function Dealers() {
  const { t } = useLang();
  return (
    <div className="bg-[#050607]" data-testid="dealers-page">
      <section className="px-5 md:px-10 pt-40 pb-20 md:pt-48 md:pb-28 border-b border-white/10">
        <FadeUp><div className="eyebrow mb-8">{t("dealers.eyebrow")}</div></FadeUp>
        <h1 className="font-display text-[40px] sm:text-[60px] lg:text-[72px] text-[#F3F3F0] max-w-5xl">
          <InviewMaskLine delay={0.2}>{t("dealers.title")}</InviewMaskLine>
        </h1>
        <FadeUp delay={0.3}><p className="mt-8 max-w-xl text-[15px] md:text-[17px] leading-relaxed text-[#999995]">{t("dealers.sub")}</p></FadeUp>
      </section>

      <section className="px-5 md:px-10 py-20 md:py-28 grid grid-cols-1 lg:grid-cols-2 gap-14 border-b border-white/10">
        <div>
          <FadeUp>
            <p className="font-display text-[20px] md:text-[26px] leading-snug text-[#F3F3F0] max-w-lg mb-10">{t("dealers.channel")}</p>
            <div className="eyebrow mb-6">{t("dealers.benefitsTitle")}</div>
          </FadeUp>
          <div className="border-t border-white/10">
            {t("dealers.benefits").map((b, i) => (
              <FadeUp key={b} delay={i * 0.04}>
                <div className="flex items-center justify-between border-b border-white/10 py-4" data-testid={`dealer-benefit-${i + 1}`}>
                  <span className="mono text-[12px] tracking-[0.14em] text-[#F3F3F0]">{b}</span>
                  <span className="mono text-[11px] text-[#555654]">{String(i + 1).padStart(2, "0")}</span>
                </div>
              </FadeUp>
            ))}
          </div>
        </div>
        <div className="self-start">
          <RevealImage src={IMG} alt="Premium vehicle sourced through the UAE market" className="aspect-[4/5] w-full max-w-[560px]" />
        </div>
      </section>

      <section className="hairline-t px-5 md:px-10 py-20 md:py-28 grid grid-cols-1 lg:grid-cols-2 gap-14 border-b border-white/10" data-testid="dealers-more">
        <div>
          <FadeUp><div className="eyebrow mb-6">01 — {t("nx.dealersMore.typesTitle")}</div></FadeUp>
          <ul className="border-t border-white/10">
            {t("nx.dealersMore.types").map((x) => (
              <li key={x} className="border-b border-white/10 py-3.5 mono text-[11px] tracking-[0.14em] text-[#F3F3F0]" data-testid="dealer-type-item">{x}</li>
            ))}
          </ul>
          <FadeUp><div className="eyebrow mb-6 mt-12">02 — {t("nx.dealersMore.howTitle")}</div></FadeUp>
          <ol className="border-t border-white/10">
            {t("nx.dealersMore.how").map((x, i) => (
              <li key={x} className="border-b border-white/10 py-4 flex items-center justify-between gap-4" data-testid="dealer-how-item">
                <span className="text-[13px] text-[#999995]">{x}</span>
                <span className="mono text-[10px] text-[#555654]">{String(i + 1).padStart(2, "0")}</span>
              </li>
            ))}
          </ol>
        </div>
        <div className="self-start w-full">
          <div className="border border-white/10 bg-[#0A0B0C] p-7 md:p-9 mb-5">
            <h3 className="mono text-[12px] tracking-[0.2em] text-[#F3F3F0] mb-4">{t("nx.dealersMore.feeTitle")}</h3>
            <p className="text-[13px] leading-relaxed text-[#8A8A86] whitespace-pre-line" data-testid="dealer-fee">{t("nx.dealersMore.fee")}</p>
          </div>
          <div className="border border-white/10 bg-[#0A0B0C] p-7 md:p-9">
            <h3 className="mono text-[12px] tracking-[0.2em] text-[#F3F3F0] mb-4">{t("nx.dealersMore.minTitle")}</h3>
            <p className="text-[13px] leading-relaxed text-[#8A8A86] whitespace-pre-line" data-testid="dealer-min">{t("nx.dealersMore.min")}</p>
          </div>
        </div>
      </section>

      <section className="px-5 md:px-10 py-20 md:py-28" data-testid="dealer-form-section">
        <FadeUp><div className="eyebrow mb-4">{t("forms.inquiry")}</div></FadeUp>
        <FadeUp delay={0.08}><h2 className="font-display text-[30px] sm:text-[42px] text-[#F3F3F0] mb-5">{t("dealers.formTitle")}</h2></FadeUp>
        <FadeUp delay={0.12}><p className="text-[14px] text-[#999995] max-w-xl mb-12">{t("forms.invite")}</p></FadeUp>
        <div className="max-w-4xl">
          <InquiryForm path="dealer" />
        </div>
      </section>
    </div>
  );
}
